const UPLOAD_FOLDER_BASE_URL = "https://blog.pss.al:8000/uploads/";

const stables = { UPLOAD_FOLDER_BASE_URL };

export default stables;
